import { createI18n } from 'vue-i18n'
import zh from './locales/zh.json'
import en from './locales/en.json'

// 获取浏览器语言或使用默认语言
const getBrowserLanguage = () => {
  const lang = navigator.language.toLowerCase()
  if (lang.includes('zh')) return 'zh'
  if (lang.includes('en')) return 'en'
  return 'zh' // Default to Chinese
}

// 从本地存储加载语言设置，如果没有则使用浏览器语言
const savedLocale = localStorage.getItem('color-extractor-locale')
const initialLocale = savedLocale || getBrowserLanguage()

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: initialLocale,
  fallbackLocale: 'en', // Fallback to English if translation is missing
  messages: {
    zh,
    en
  }
})

export default i18n
